/**
 * Created by Shiv Roy on 21/12/17.
 */
import { patientActionTypes } from './../constants/ApiConstants';

const initialState = {
  loading: false,
  patientImmunizationList: null,
  patientMedicationList: null,
  patientLabsList: null,
  patientAppointmentList: null,
  patientAllergiesList: null,
  patientInsuranceList: null,
  patientAuthorizationList: null,
  patientFamilyHistoryList: null,
  office_hours: null,
  encounter_detail: null,
  saved_soap: null,
  appointment: null,
  patientEncouterNonBillableDetail: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case patientActionTypes.get_patient_details.REQUEST:
  case patientActionTypes.get_patient_immunization.REQUEST:
  case patientActionTypes.get_patient_medication.REQUEST:
  case patientActionTypes.get_patient_labs.REQUEST:
  case patientActionTypes.get_patient_appointment.REQUEST:
  case patientActionTypes.get_patient_allergy.REQUEST:
  case patientActionTypes.get_patient_authorization.REQUEST:
  case patientActionTypes.get_patient_family_history.REQUEST:
  case patientActionTypes.get_office_hours.REQUEST:
  case patientActionTypes.post_patient_soap.REQUEST:
  case patientActionTypes.create_claim.REQUEST:
    return {
      ...state,
      loading: true,
    };

  case patientActionTypes.get_patient_details.SUCCESS:
    return {
      ...state,
      loading: false,
      patientPortalDetails: payload.data,
    };
  case patientActionTypes.get_patient_immunization.SUCCESS:
    return {
      ...state,
      loading: false,
      patientImmunizationList: payload,
    };
  case patientActionTypes.get_patient_medication.SUCCESS:
    return {
      ...state,
      loading: false,
      patientMedicationList: payload,
    };
  case patientActionTypes.get_patient_labs.SUCCESS:
    return {
      ...state,
      loading: false,
      patientLabsList: payload,
    };
  case patientActionTypes.get_patient_appointment.SUCCESS:
    return {
      ...state,
      loading: false,
      patientAppointmentList: payload,
    };
  case patientActionTypes.get_patient_allergy.SUCCESS:
    return {
      ...state,
      loading: false,
      patientAllergiesList: payload,
    };
  case patientActionTypes.get_patient_insurance.REQUEST:
    return {
      ...state,
      loading: true,
      patientInsuranceList: null,
    };
  case patientActionTypes.get_patient_insurance.SUCCESS:
    return {
      ...state,
      loading: false,
      patientInsuranceList: payload,
    };
  case patientActionTypes.get_patient_authorization.SUCCESS:
    return {
      ...state,
      loading: false,
      patientAuthorizationList: payload,
    };
  case patientActionTypes.get_patient_family_history.SUCCESS:
    return {
      ...state,
      loading: false,
      patientFamilyHistoryList: payload,
    };
  case patientActionTypes.get_office_hours.SUCCESS:
    return {
      ...state,
      loading: false,
      office_hours: payload,
    };
  case patientActionTypes.get_patient_single_encounter.REQUEST:
    return {
      ...state,
      loading: true,
      encounter_detail: null,
    };
  case patientActionTypes.get_patient_single_encounter.SUCCESS:
    return {
      ...state,
      loading: false,
      encounter_detail: payload,
    };
  case patientActionTypes.post_patient_soap.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_soap: payload,
    };

  case patientActionTypes.get_appointment_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      appointment: null,
    };
  case patientActionTypes.get_appointment_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment: payload,
    };
  case patientActionTypes.get_patient_encounter_nonBillable.REQUEST:
    return {
      ...state,
      loading: true,
      patientEncouterNonBillableDetail: null,
    };
  case patientActionTypes.get_patient_encounter_nonBillable.SUCCESS:
    return {
      ...state,
      loading: false,
      patientEncouterNonBillableDetail: payload,
    };
  case patientActionTypes.create_claim.SUCCESS:
  case patientActionTypes.create_claim.FAILURE:
      return {
        ...state,
        loading: false,
      };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/reducers/index.js